module.exports = __webpack_public_path__ + "img/divider2-1.6215ceb0.jpeg";